import clsx from "clsx";
import BuyerInfo from "components/pages/personal/cart/buyerInfo";
import Recipient from "components/pages/personal/cart/recipient";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import Button from "~/components/common/button";
import Icon from "~/components/common/icon";
import { showPopup } from "~/redux/action-creaters/popup";
import { popupTypes } from "~/redux/reducers/popupReducer";
import { DeliveryTypes, UserFields } from "~/types/cart";

import Address from "./address";
import Delivery from "./delivery";
import EdostMap from "./deliveryMap/edostMap";
import SdekMap from "./deliveryMap/sdekMap";
import ShopsMap from "./deliveryMap/shopsMap";
import styles from "./index.module.scss";
import InstalTime from "./instalTime";

enum errorTypes {
  deliveryType = "deliveryType",
  point = "point",
}

export default function Step1({ isManagerDelivery = false }) {
  const { errors } = useSelector((state: any) => state.cart);
  const dispatch = useDispatch();
  const { params, deliveryList } = useSelector((state: any) => state.cart);
  const { cityName, deliveryCityData } = useSelector(
    (state: any) => state.location,
  );

  const deliveyType = useMemo(() => {
    return params[UserFields.deliveryId]
      ? deliveryList.find(
          (item: any) => item.ID === params[UserFields.deliveryId],
        )
      : {};
  }, [params, deliveryList]);

  const isNeedAdr = useMemo(() => {
    return [DeliveryTypes.courier, DeliveryTypes.edostCourier].includes(
      deliveyType?.TYPE,
    );
  }, [deliveyType]);

  const isNeedDeliveryDate = useMemo(() => {
    return [DeliveryTypes.courier].includes(deliveyType?.TYPE);
  }, [deliveyType]);

  const isNeedInstallTime = useMemo(() => {
    return [DeliveryTypes.install].includes(deliveyType?.TYPE);
  }, [deliveyType]);

  const isShowMap = useMemo(() => {
    return [
      DeliveryTypes.edost,
      DeliveryTypes.sdek,
      DeliveryTypes.install,
      DeliveryTypes.pickup,
    ].includes(deliveyType?.TYPE);
  }, [deliveyType]);

  const region = useMemo(() => {
    return deliveryCityData?.region_with_type;
  }, [deliveryCityData]);

  return (
    <div className={styles.Body}>
      {cityName === "Россия" && (
        <div className="text">
          <div className="block-attention">
            <span className={styles.EmptyCity}>
              Для продолжения выберите город:
              <Button
                customStyles={styles.FormButton}
                label="Выбрать город"
                onClick={() => {
                  dispatch(showPopup(popupTypes.locationNew));
                }}
              />
            </span>
          </div>
        </div>
      )}
      {cityName !== "Россия" && (
        <>
          <div className={styles.Obtain}>
            <div className={styles.Title}>
              Способ получения заказа в
              {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
              <span
                className={styles.Location}
                onClick={() => dispatch(showPopup(popupTypes.locationNew))}
              >
                {cityName}
                {region ? `, ${region}` : ""}
                <Icon id="next" width={15} height={13} stroke="#1247a5" />
              </span>
            </div>
            <div className={styles.Delivery}>
              {errors.includes(errorTypes.deliveryType) && (
                <div className={clsx(styles.Errors, "error")}>
                  Выберите способ доставки
                </div>
              )}
              <Delivery />
            </div>
          </div>
          {isShowMap && (
            <div className={styles.Map}>
              {deliveyType.TYPE === DeliveryTypes.edost && (
                <EdostMap isError={errors.includes(errorTypes.point)} />
              )}
              {deliveyType.TYPE === DeliveryTypes.sdek && (
                <SdekMap isError={errors.includes(errorTypes.point)} />
              )}
              {(deliveyType.TYPE === DeliveryTypes.install ||
                deliveyType.TYPE === DeliveryTypes.pickup) && (
                <ShopsMap
                  isError={errors.includes(errorTypes.point)}
                  type={deliveyType.TYPE}
                />
              )}
            </div>
          )}
          {!isManagerDelivery && (
            <>
              {isNeedInstallTime && <InstalTime />}
              {isNeedAdr && <Address />}
              <Recipient />
              <BuyerInfo />
            </>
          )}
        </>
      )}
    </div>
  );
}
